import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_bonus_payments = _resolveComponent("bonus-payments")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Punti",
          text: "Punti"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "number",
        step: "0.1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.points) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.points]
      ])
    ]),
    _createVNode(_component_bonus_payments, {
      modelValue: _ctx.localValue.bonusPayments,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.bonusPayments) = $event))
    }, null, 8, ["modelValue"])
  ]))
}